$(document).ready(function () {
  "use strict";

  $(".ham-menu").click(function (event) {
    event.stopPropagation();
    $(".mobile-menu-wrapper").toggleClass("active");
    $(".ham-menu").toggleClass("active");
  });

  // Menu dropdown mobile avec animation smooth
  $(".drop-down-menu-btn").on("click", function (e) {
    // Ne pas suivre le lien si c'est un sous-menu
    const hasSubMenu =
      $(this).siblings(".mobile-drop-down-menu-wrapper").length > 0;
    if (hasSubMenu) {
      e.preventDefault();

      const $wrapper = $(this).siblings(".mobile-drop-down-menu-wrapper");
      const $icon = $(this).find("i");

      // Fermer les autres sous-menus
      $(".mobile-drop-down-menu-wrapper").not($wrapper).removeClass("active");
      $(".drop-down-menu-btn i").not($icon).removeClass("rotate");

      // Toggle le sous-menu actuel avec classe CSS uniquement
      $wrapper.toggleClass("active");
      $icon.toggleClass("rotate");
    }
  });
  //..navbar mobile-menu js end..//

  // product quantity js start--//
  $(".qty-increase").click(function () {
    var qty = parseInt($(".quantity-total").val()) + 1;
    $(".quantity-total").val(qty);
    $("#quantity").val(qty);
  });

  $(".qty-decrease").click(function () {
    var currentValue = parseInt($(".quantity-total").val());
    if (currentValue > 1) {
      currentValue -= 1;
      $(".quantity-total").val(currentValue);
      $("#quantity").val(currentValue);
    }
  });
  // product quantity js end--//

  // --tab js start--
  $(".tab-nav-item:first-child").addClass("active");
  $(".desktop-tab-content-item").hide();
  $(".desktop-tab-content-item:first").show();

  $(".desktop-tabs-nav-item-link").click(function () {
    $(".tab-nav-item").removeClass("active");
    $(this).parent().addClass("active");
    $(".desktop-tab-content-item").hide();

    var activeTab = $(this).attr("href");
    $(activeTab).fadeIn();
    return false;
  });
  // --tab js end--

  // --mobile-tab js start--
  $(".mobile-tab-content-item:first-child").addClass("active");
  $(".mobile-tab-content-item").hide();
  $(".mobile-tab-content-item:first").show();

  $(".tabs-nav-item-mobile-link").click(function () {
    $(".tab-nav-item").removeClass("active");
    $(this).parent().addClass("active");
    $(".mobile-tab-content-item").hide();

    var activeTab = $(this).attr("href");
    $(activeTab).fadeIn();
    return false;
  });
  // --mobile-tab js end--
});

// product slider js start--
var swiper = new Swiper(".product-slider", {
  slidesPerView: 3,
  spaceBetween: 15,
  grabCursor: true,
  loop: true,
  speed: 500,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    // when window width is >= 320px
    1: {
      slidesPerView: 1,
    },
    // when window width is >= 576px
    576: {
      slidesPerView: 1,
    },
    // when window width is >= 768px
    768: {
      slidesPerView: 2,
    },
    // when window width is >= 993px
    993: {
      slidesPerView: 3,
    },
  },
});
// product slider js end--

// **..product-single-slider js start..**
var swiper = new Swiper(".single-product-swiper", {
  loop: true,
  spaceBetween: 16,
  slidesPerView: 5,
  freeMode: true,
  watchSlidesProgress: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
var swiper2 = new Swiper(".single-product-swiper-2", {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiper,
  },
  breakpoints: {
    // when window width is >= 320px
    1: {
      slidesPerView: 1.3,
    },
    // when window width is >= 576px
    576: {
      slidesPerView: 1.3,
    },
    // when window width is >= 768px
    768: {
      slidesPerView: 1,
    },
    // when window width is >= 993px
    993: {
      slidesPerView: 1,
    },
  },
});
// **..product-single-slider js end..**

// img slider js start--
var swiper = new Swiper(".img-slider", {
  slidesPerView: 4.5,
  spaceBetween: 22,
  grabCursor: true,
  loop: true,
  speed: 500,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  breakpoints: {
    // when window width is >= 320px
    1: {
      slidesPerView: 2.25,
      spaceBetween: 10,
    },
    // when window width is >= 576px
    576: {
      slidesPerView: 2.5,
      spaceBetween: 10,
    },
    // when window width is >= 768px
    768: {
      slidesPerView: 3.5,
      spaceBetween: 15,
    },
    // when window width is >= 993px
    993: {
      slidesPerView: 4.5,
    },
  },
});
// img slider js end--

// **..faq section js start..**
$(".accordion-toggle-btn").on("click", function () {
  $(this).next().slideToggle();
  $(this).parent().toggleClass("active");
});
// **..faq section js end..**

// content animation--
new WOW().init();

$(document).ready(function () {
  $(".price-filter").on("click", function (event) {
    event.stopPropagation();
    $(".price-input-wrap").toggleClass("show");
    $(this).parent().siblings().find(".filter-field-items").removeClass("show");
  });

  $(".filter-label").on("click", function (event) {
    event.stopPropagation();
    $(this).next().toggleClass("show");
    $(this)
      .parent()
      .siblings()
      .find(".filter-field-items, .price-input-wrap")
      .removeClass("show");
  });

  $(".price-input-wrap, .filter-field-items").on("click", function (event) {
    event.stopPropagation();
  });

  // Close dropdowns when clicking outside
  $(document).on("click", function (event) {
    if (
      !$(event.target).closest(
        ".price-input-wrap, .price-filter, .filter-label"
      ).length
    ) {
      $(".price-input-wrap").removeClass("show");
      $(".filter-field-items").removeClass("show"); // Close other filter dropdowns
    }
  });

  $("#sort_by").on("change", function () {
    var sort = $(this).val();
    var min_price = $("#min_price").val();
    var max_price = $("#max_price").val();
    var coll = $(".collection_name").val();

    if (coll == "products") {
      coll = "all";
    } else {
      coll = $(".collection_name").val();
    }
    var prices =
      "filter.v.price.gte=" + min_price + "&filter.v.price.lte=" + max_price;
    var option_name = "";
    $(".filter-item-checkbox:checked").each(function (index, element) {
      if (index !== length - 1) {
        option_name += $(this).data("option") + "=";
        option_name += $(this).val() + "&";
      } else {
        option_name += $(this).data("option") + "=";
        option_name += $(this).val();
      }
    });
    if (option_name != "") {
      var url =
        "/collections/" +
        coll +
        "?" +
        option_name +
        "&" +
        prices +
        "&sort_by=" +
        sort;
      var filter_url =
        "/collections/" +
        coll +
        "?" +
        option_name +
        "&" +
        prices +
        "&sort_by=" +
        sort;
      window.history.pushState({}, null, filter_url);
      filter_update(url);
    } else {
      var url = "/collections/" + coll + prices + "&sort_by=" + sort;
      var filter_url = "/collections/" + coll + +prices + "&sort_by=" + sort;
      window.history.pushState({}, null, filter_url);
      filter_update(url);
    }
  });

  // price filter
  $(".price_filter").on("keyup", function () {
    var sort = $("#sort_by option:selected").val();
    var min_price = $("#min_price").val();
    var max_price = $("#max_price").val();
    var coll = $(".collection_name").val();

    if (coll == "products") {
      coll = "all";
    } else {
      coll = $(".collection_name").val();
    }
    var prices =
      "filter.v.price.gte=" + min_price + "&filter.v.price.lte=" + max_price;
    var option_name = "";
    $(".filter-item-checkbox:checked").each(function (index, element) {
      if (index !== length - 1) {
        option_name += $(this).data("option") + "=";
        option_name += $(this).val() + "&";
      } else {
        option_name += $(this).data("option") + "=";
        option_name += $(this).val();
      }
    });
    if (option_name != "") {
      var url =
        "/collections/" +
        coll +
        "?" +
        option_name +
        "&" +
        prices +
        "&sort_by=" +
        sort;
      var filter_url =
        "/collections/" +
        coll +
        "?" +
        option_name +
        "&" +
        prices +
        "&sort_by=" +
        sort;
      window.history.pushState({}, null, filter_url);
      filter_update(url);
    } else {
      var url = "/collections/" + coll + prices + "&sort_by=" + sort;
      var filter_url = "/collections/" + coll + +prices + "&sort_by=" + sort;
      window.history.pushState({}, null, filter_url);
      filter_update(url);
    }
  });

  // if variation is radio value
  $(".option_input").on("change", function () {
    let optionName = "";
    $("input:radio.option_input:checked").each(function (e) {
      optionName += e != 0 ? "-" : "";
      optionName += $(this).val();
    });

    $("#productSelect option").each(function () {
      var txt = $.trim($(this).text());
      if (txt == optionName) {
        $(this).parent().val($(this).val());
        var id = $(this).val();
        var price = $(this).data("price");
        var compare_price = $(this).data("compare");
        var available = $(this).data("available");

        $("#product_id").val(id);
        if (available == true) {
          $(".product-btn").removeClass("sold_out").text("ajouter au panier");
        } else {
          $(".product-btn").addClass("sold_out").text("Épuisé");
        }
      }
    });
  });

  $(".forget-btn").on("click", function () {
    $(".login-form-area").hide();
    $(".recover-form-wrap").show();
  });

  $(".cancel-btn").on("click", function () {
    $(".login-form-area").show();
    $(".recover-form-wrap").hide();
  });

  $(window).on("load scroll", function () {
    if ($(this).scrollTop() > 1) {
      $("header").addClass("sticky");
    } else {
      $("header").removeClass("sticky");
    }
  });
});
